export enum DisplayViewOptionsEnum {
  LOW_FARE = 'low_fare',
  FARE_PICKER = 'fare_picker',
  CONFIRM_TRIP = 'confirm_trip',
}

export type DisplayViewOptions = DisplayViewOptionsEnum;

export enum CalendarModeEnum {
  MONTH = 'month',
  WEEK = 'week',
}

export type CalendarModes = CalendarModeEnum;

export const StationCodesUSA = [
  'JFK',
  'LAS',
  'LAX',
  'MIA',
  'MCO',
];

export const StationCodesUK = [
  'LGW',
];
